import { FC } from "react";

import { SubmenuTitle as UISubmenuTitle } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/components/SubmenuTitle/SubmenuTitle";

import { submenuTitleInputs } from "./SubmenuTitle.builder";

type SubmenuTitleBuilderProps = BuilderComponentProps<
  typeof submenuTitleInputs
>;

export const SubmenuTitle: FC<SubmenuTitleBuilderProps> = ({
  title,
  descriptionPrefix,
  secondDescriptionPrefix,
  link,
  variant,
}) => {
  return (
    <UISubmenuTitle
      title={title}
      descriptionPrefix={descriptionPrefix}
      secondDescriptionPrefix={secondDescriptionPrefix}
      link={link}
      variant={variant}
    />
  );
};
